import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";

function usePModelDetail(params) {

  return useSWR(
  params?.id ? 
    {
      path: `/api/v1/products/${params?.id}/product-models`,
      method: "GET",
      params,
    }: null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default usePModelDetail;
